import { marked } from 'marked'

function formatJobDescription(text) {
  const formattedDescription = marked(text)

  return formattedDescription
}

export default formatJobDescription
